export default __webpack_public_path__ + "static/media/tyler.03b142fc.JPG";